module.exports = __webpack_public_path__ + "static/media/vector.a3ea1648.svg";